import { render } from "./Farmer.vue?vue&type=template&id=4eeb5e3e&scoped=true&ts=true"
import script from "./Farmer.vue?vue&type=script&lang=ts"
export * from "./Farmer.vue?vue&type=script&lang=ts"

import "./Farmer.vue?vue&type=style&index=0&id=4eeb5e3e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eeb5e3e"]])

export default __exports__